import { GWCA } from '~/lib/ca-constants';
import { GWCustomerAccountsTab } from './ca-tab';

customElements.define(
  'gw-customer-accounts-profile',
  class GWCustomerAccountsProfile extends GWCustomerAccountsTab {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.querySelector('[data-logout-button]')?.addEventListener('click', function (event) {
        event.preventDefault();
        this.querySelector('[data-loader]').hidden = false;

        localStorage.removeItem(GWCA.STORAGE_KEYS.TOKEN);
        localStorage.removeItem(GWCA.STORAGE_KEYS.EMAIL);

        document.dispatchEvent(new CustomEvent('gw-customer-accounts:logout'));

        window.location.href = '/account/logout';
      });
    }
  }
);

customElements.define(
  'gw-address-item',
  class GWAddressItem extends HTMLElement {
    constructor() {
      super();

      this.addressId = this.getAttribute('address-id');
      this.addressUrl = this.getAttribute('address-url');
      this.addressDetailSectionId = 'ca-address-edit-detail';
      this.addressDrawerId = 'Drawer-' + this.addressId;
      this.addressesContainer = this.closest('[data-gw-addresses-list]');
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        const addressDetailDrawer = this.addressesContainer.querySelector(`#${this.addressDrawerId}`);
        if (addressDetailDrawer) {
          addressDetailDrawer.show();
        } else {
          this._openAddressDetailsDrawer();
        }
      });
    }

    async _openAddressDetailsDrawer() {
      const addressDetails = await this._fetchAddressTemplate(this.addressUrl, this.addressDetailSectionId);
      const html = new DOMParser().parseFromString(addressDetails, 'text/html');
      const addressDetailDrawer = html.getElementById('Drawer-' + this.addressId);

      this.addressesContainer.appendChild(addressDetailDrawer);

      if (addressDetailDrawer) {
        await new Promise((resolve) => requestAnimationFrame(resolve));
        addressDetailDrawer.show();
      }
    }

    async _fetchAddressTemplate(addressUrl, sectionId) {
      try {
        const url = addressUrl.concat(`?section_id=${sectionId}`);
        const response = await fetch(url);
        return response.text();
      } catch (err) {
        console.error(err);
      }
    }
  }
);

customElements.define(
  'gw-add-address-button',
  class GWAddAddressButton extends HTMLElement {
    constructor() {
      super();

      this.addAddressButton = this.querySelector('button');
      this.addAddressUrl = this.getAttribute('add-address-url') || '/';
      this.addAddressSectionId = 'ca-address-add-detail';
      this.addAddressDrawerId = 'Drawer-Add_Address';
      this.addressesContainer = this.parentElement;
    }

    connectedCallback() {
      console.log('add address button connected', this.addAddressButton);
      this.addAddressButton.addEventListener('click', () => {
        console.log('add address button clicked');
        const addAddressDrawer = this.addressesContainer.querySelector(`#${this.addAddressDrawerId}`);
        if (addAddressDrawer) {
          addAddressDrawer.show();
        } else {
          this._openAddAddressDrawer();
        }
      });
    }

    async _openAddAddressDrawer() {
      const addAddressDetails = await this._fetchAddressTemplate(this.addAddressUrl, this.addAddressSectionId);
      const html = new DOMParser().parseFromString(addAddressDetails, 'text/html');
      const addAddressSection = html.getElementById('shopify-section-' + this.addAddressSectionId);

      this.addressesContainer.appendChild(addAddressSection);

      const addAddressDrawer = this.addressesContainer.querySelector(`#${this.addAddressDrawerId}`);
      if (addAddressDrawer) {
        await new Promise((resolve) => requestAnimationFrame(resolve));
        addAddressDrawer.show();
      }
    }

    async _fetchAddressTemplate(addressUrl, sectionId) {
      try {
        const url = addressUrl.concat(`?section_id=${sectionId}`);
        const response = await fetch(url);
        return response.text();
      } catch (err) {
        console.error(err);
      }
    }
  }
);
